import React, { createContext, useContext, useState } from 'react';
import { BusinessCardData } from '../../components/CardsComponents/types';

const BusinessContext = createContext<{
  business: BusinessCardData | null;
  setBusiness: (business: BusinessCardData | null) => void;
  selectedOption: 'full' | 'installment';
  setSelectedOption: (option: 'full' | 'installment') => void;
}>({ business: null, setBusiness: () => {}, selectedOption: 'full', setSelectedOption: () => {} });

export const BusinessProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [business, setBusiness] = useState<BusinessCardData | null>(null);
  const [selectedOption, setSelectedOption] = useState<'full' | 'installment'>('full');

  return (
    <BusinessContext.Provider value={{ business, setBusiness, selectedOption, setSelectedOption }}>
      {children}
    </BusinessContext.Provider>
  );
};

export const useBusiness = () => useContext(BusinessContext);